import { BookOpenCheck, BrainCircuit, Clapperboard, GitCommitHorizontal, LibraryBig, PenLine, UsersRound } from "lucide-react";

import { useStoryPreferences } from "../i18n";

export type WorkspaceView = "write" | "world" | "version" | "context" | "intelligence" | "production" | "collaboration";
type WorkspaceNavProps = { active: WorkspaceView; onChange: (view: WorkspaceView) => void };

export function WorkspaceNav({ active, onChange }: WorkspaceNavProps) {
  const { t } = useStoryPreferences();
  return (
    <nav className="workspace-nav" aria-label={t("workspaceLabel")}>
      <div className="workspace-tabs">
        <button type="button" className={`workspace-tab${active === "write" ? " active" : ""}`} onClick={() => onChange("write")}><PenLine />{t("write")}</button>
        <button type="button" className={`workspace-tab${active === "world" ? " active" : ""}`} onClick={() => onChange("world")}><BookOpenCheck />{t("world")}</button>
        <button type="button" className={`workspace-tab${active === "version" ? " active" : ""}`} onClick={() => onChange("version")}><GitCommitHorizontal />{t("version")}</button>
        <button type="button" className={`workspace-tab${active === "context" ? " active" : ""}`} onClick={() => onChange("context")}><BrainCircuit />{t("contextAi")}</button>
        <button type="button" className={`workspace-tab${active === "intelligence" ? " active" : ""}`} onClick={() => onChange("intelligence")}><LibraryBig />{t("intelligence")}</button>
        <button type="button" className={`workspace-tab${active === "production" ? " active" : ""}`} onClick={() => onChange("production")}><Clapperboard />{t("production")}</button>
        <button type="button" className={`workspace-tab${active === "collaboration" ? " active" : ""}`} onClick={() => onChange("collaboration")}><UsersRound />{t("collaborationGame")}</button>
      </div>
    </nav>
  );
}
